import { render, staticRenderFns } from "./KanbanContext.vue?vue&type=template&id=469dab91&scoped=true&"
import script from "./KanbanContext.vue?vue&type=script&lang=js&"
export * from "./KanbanContext.vue?vue&type=script&lang=js&"
import style0 from "./KanbanContext.vue?vue&type=style&index=0&id=469dab91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469dab91",
  null
  
)

export default component.exports